import { render, staticRenderFns } from "./LayoutBento.vue?vue&type=template&id=24768ea1&scoped=true"
import script from "./LayoutBento.vue?vue&type=script&lang=js"
export * from "./LayoutBento.vue?vue&type=script&lang=js"
import style0 from "./LayoutBento.vue?vue&type=style&index=0&id=24768ea1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24768ea1",
  null
  
)

export default component.exports